export const About = ({ t }) => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 md:py-40 border-t border-[#183321]/10"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-8">
              <span className="w-10 h-px bg-[#183321]/40" />
              <span className="text-xs uppercase tracking-[0.25em] text-[#4A6B53] font-semibold">
                {t.about.eyebrow}
              </span>
            </div>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-[#183321] font-medium">
              {t.about.title}
            </h2>

            <div className="mt-12 aspect-[4/3] overflow-hidden rounded-sm">
              <img
                src="https://images.pexels.com/photos/5802827/pexels-photo-5802827.jpeg"
                alt="Surveyor at construction site"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>

          <div className="lg:col-span-6 lg:col-start-7 flex flex-col gap-10">
            <p className="text-lg md:text-xl leading-relaxed text-[#183321] font-serif">
              {t.about.body_1}
            </p>
            <p className="text-base md:text-lg leading-relaxed text-[#4A6B53]">
              {t.about.body_2}
            </p>

            <div className="grid grid-cols-3 gap-6 mt-8 pt-10 border-t border-[#183321]/15">
              <div data-testid="stat-founded">
                <div className="font-serif text-5xl md:text-6xl text-[#2A4D35] leading-none">
                  2015
                </div>
                <div className="mt-3 text-xs uppercase tracking-widest text-[#4A6B53]">
                  {t.about.stat_1}
                </div>
              </div>
              <div data-testid="stat-disciplines">
                <div className="font-serif text-5xl md:text-6xl text-[#2A4D35] leading-none">
                  03
                </div>
                <div className="mt-3 text-xs uppercase tracking-widest text-[#4A6B53]">
                  {t.about.stat_2}
                </div>
              </div>
              <div data-testid="stat-sectors">
                <div className="font-serif text-2xl md:text-3xl text-[#2A4D35] leading-tight">
                  {t.about.stat_3_value}
                </div>
                <div className="mt-3 text-xs uppercase tracking-widest text-[#4A6B53]">
                  {t.about.stat_3}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
